import { hasClerkUser } from '@/biz/tool';
import { useLoginStore } from '@/hooks/useLoginStore';
import { Tooltip } from 'aha-components';
import { TableSortDefaultIcon } from '../common/icon';

export default function Avatar({ compact }: { compact?: boolean }) {
  const { channelAvatar, channelName, userEmail } = useLoginStore();
  const avatarImg = (
    <img
      alt="avatar"
      src={
        hasClerkUser()
          ? channelAvatar || '/c-avatar-empty.svg'
          : '/c-avatar-empty.svg'
      }
      className={
        compact
          ? 'w-10 h-10 rounded-full cursor-pointer'
          : 'w-10 h-10 rounded-full border border-[#00000014] cursor-pointer'
      }
      onError={({ currentTarget }) => {
        currentTarget.onerror = null;
        currentTarget.src = '/c-avatar-empty.svg';
        console.error('youtube avatar failed!!! ' + channelAvatar);
      }}
    />
  );

  if (compact) {
    return avatarImg;
  }

  return (
    <div className="border border-[#E7E5E4] p-3 flex justify-between rounded-[12px] cursor-pointer">
      <div className="flex items-center gap-2">
        {avatarImg}
        <div className="flex flex-col justify-start items-start">
          <Tooltip content={channelName} className="w-full">
            <div className="text-[#1C1917] text-sm font-semibold font-['DM_Sans'] leading-5 md:max-w-[160px] text-ellipsis overflow-hidden">
              {channelName || '-'}
            </div>
          </Tooltip>
          <Tooltip content={userEmail} className="w-full">
            <div className="text-[#57534E] text-sm font-normal font-['DM_Sans'] leading-5 line-clamp-1  md:max-w-[160px] text-ellipsis overflow-hidden">
              {userEmail}
            </div>
          </Tooltip>
        </div>
      </div>
      <div className="bg-[#FAFAF9] w-8 h-8 rounded-[4px] flex items-center justify-center cursor-pointer">
        <TableSortDefaultIcon className="w-[20px] h-[20px] text-[#79716B]" />
      </div>
    </div>
  );
}
